import { z } from "zod";
import { BatchSet } from "./batch-set.js";

// isolatedDeclarations: annotate the shape type explicitly so tsc can emit declarations
// without reading across module boundaries. We define the output shape as a TS interface
// and use z.ZodType<Output> on the exported const.

// D-25: print options + batch-set-name vocabulary are spread-local; they live on SpreadOptions.
export interface SpreadOptions {
  batchSetNameLabel?: string | undefined;
  printOptions?: Record<string, unknown> | undefined;
}

export const SpreadOptions: z.ZodType<SpreadOptions> = z.strictObject({
  batchSetNameLabel: z.string().min(1).max(100).optional(),
  printOptions: z.record(z.string(), z.unknown()).optional(),
});

export interface Spread {
  id: string;
  name: string;
  batchSets: readonly BatchSet[];
  spreadOptions?: SpreadOptions | undefined;
}

export const Spread: z.ZodType<Spread> = z.strictObject({
  id: z.string().min(1).max(100),
  name: z.string().min(1).max(200),
  // D-11: Spread owns 1+ BatchSets; bounded at 20 (T-01.1-26 DoS mitigation)
  batchSets: z.array(BatchSet).min(1).max(20),
  spreadOptions: SpreadOptions.optional(),
});
